module.exports = __webpack_public_path__ + "static/media/m_eyeshape_hooded_blue.f9f03be7.png";